module.exports = __webpack_public_path__ + "img/desk.701d14c0.png";